var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "periodicTable",
      staticClass: "sk-table",
      staticStyle: { width: "100%" },
      attrs: { data: _vm.sortedData, border: true },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _c("el-table-column", {
        attrs: { type: "selection", width: "45", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { label: "STT", type: "index", width: "50", align: "center" },
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tên học sinh",
          prop: "studentName",
          "min-width": "180",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "div",
                  { staticClass: "pev-student-cell" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "pev-student-name",
                        class: {
                          "pev-student-name--leave": !_vm.isStudying(row),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.studentName) +
                            "\n        "
                        ),
                      ]
                    ),
                    !_vm.isStudying(row)
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "pev-leave-tag",
                            attrs: { size: "mini", type: "info" },
                          },
                          [_vm._v("\n          Đã chuyển\n        ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Số lần", width: "100", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("span", { staticClass: "pev-period-count" }, [
                  _vm._v(_vm._s(_vm.getPeriodCount(row))),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Trạng thái", width: "130", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type: _vm.getOverallApprovalType(row),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getOverallApprovalLabel(row)) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Lần gần nhất", "min-width": "250" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? [
                      _c(
                        "div",
                        { staticClass: "pev-latest-eval" },
                        [
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "info" } },
                            [
                              _vm._v(
                                "Lần " +
                                  _vm._s(
                                    _vm.getLatestEvaluation(row).periodNumber
                                  )
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "pev-latest-content" }, [
                            _vm._v(
                              _vm._s(
                                _vm.truncateContent(
                                  _vm.getLatestEvaluation(row).content
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("Chưa có nhận xét"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "File", width: "80", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? [
                      _vm.getFileCount(_vm.getLatestEvaluation(row)) > 0
                        ? _c("span", { staticClass: "pev-file-count" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.$emit(
                                      "view-files",
                                      _vm.getEvaluationFiles(
                                        _vm.getLatestEvaluation(row)
                                      )
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-paperclip" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getFileCount(
                                        _vm.getLatestEvaluation(row)
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ])
                        : _c("span", { staticClass: "text-slate-400" }, [
                            _vm._v("—"),
                          ]),
                    ]
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Phản hồi", width: "90", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "pev-reply-badge",
                    class: {
                      "pev-reply-badge--active": _vm.getTotalReplies(row) > 0,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-chat-dot-round" }),
                    _vm._v(" " + _vm._s(_vm.getTotalReplies(row)) + "\n      "),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Thao tác",
          width: "250",
          align: "center",
          fixed: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-nowrap justify-center gap-1" },
                  [
                    _vm.isStudying(row)
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Tạo nhận xét",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "success",
                                icon: "el-icon-plus",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("add", row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Xem", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-view",
                            size: "mini",
                            circle: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("view", row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    row.evaluations && row.evaluations.length > 0
                      ? _c(
                          "el-tooltip",
                          { attrs: { content: "Sửa", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-edit",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("edit", row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    row.evaluations &&
                    row.evaluations.length > 0 &&
                    _vm.hasUnapproved(row)
                      ? _c(
                          "el-tooltip",
                          { attrs: { content: "Duyệt", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "success",
                                icon: "el-icon-check",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("approve", row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    row.evaluations && row.evaluations.length > 0
                      ? _c(
                          "el-tooltip",
                          { attrs: { content: "Lịch sử", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "info",
                                icon: "el-icon-time",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("history", row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    row.evaluations && row.evaluations.length > 0
                      ? _c(
                          "el-tooltip",
                          { attrs: { content: "Xoá", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("delete", row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }